import { defaultValue, makeText, setHtml } from '../lib.js';
import { fadeInTimeoutMS, fadeOut, handleFadeInOut, isClickOutside, isClicked, saveClick } from './utils.js';

const defaultText = defaultValue(`You can upload photos from your camera roll and have them printed at the kiosk!`);

export function show(text) {
  if (!isClicked('uploadPhotoBtnClicked')) {
    const element = makeText('.ugc-tooltip__text');
    setHtml(defaultText(text), element);

    if (isClicked('faceRecoBtnClicked')) {
      setTimeout(() => handleFadeInOut('.ugc-tooltip'), fadeInTimeoutMS);
    }

    document.addEventListener('click', (event) => {
      const selectors = ['.top-panel', '.menu', '#qrr-overlay', '#qrr-container'];
      if (isClickOutside(event, selectors)) {
        fadeOut('.ugc-tooltip');
      }
    });
  }
}

export function Off() {
  saveClick('uploadPhotoBtnClicked');
  fadeOut('.ugc-tooltip');
}
